import Vue from "vue"
import Router from "vue-router"
import { publicRoute, protectedRoute } from "./config"
import { getJWT} from "../store/module/helper";
import NProgress from "nprogress"
import "nprogress/nprogress.css"
const routes = publicRoute.concat(protectedRoute)

Vue.use(Router)
const router = new Router({
  mode: "hash",
  linkActiveClass: "active",
  routes: routes
})
// router guards
router.beforeEach((to, from, next) => {
  NProgress.start()
  //auth route is authenticated
  if(to.name == "login"){
    console.log('masuk if login')
    next()
  }

  else if(getJWT()){
    console.log('masuk if jwt')
    next()
  }

  else {
    console.log('masuk else')
    next("/login")
  }
})

router.afterEach((to, from) => {
  NProgress.done()
})

export default router
